<ngx-loading-bar [color]="'red'"></ngx-loading-bar>

<router-outlet></router-outlet>
